import React, { useEffect, useRef, useState } from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import filterFactory, { textFilter, customFilter } from 'react-bootstrap-table2-filter';
import PropTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.css';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import ColumnFilter from '../components/ColumnFilter';

export default function MycustomDesignGrid(props) {
    const { ExportCSVButton } = CSVExport;
    const columns = [{
        dataField: 'id',
        text: 'Product ID'
    }, {
        dataField: 'name',
        text: 'Product Name'
    }, {
        dataField: 'price',
        text: 'Product Price'
    }];

    const demodata = [];

    const sizePerPageRenderer = ({
        options,
        currSizePerPage,
        onSizePerPageChange
    }) => (
        <div className="btn-group" role="group">
            {
                options.map((option) => {
                    // debugger;
                    const isSelect = currSizePerPage === `${option.page}`;
                    return (
                        <button
                            key={option.text}
                            type="button"
                            onClick={() => onSizePerPageChange(option.page)}
                            className={`btn ${isSelect ? 'btn-secondary' : 'btn-warning'}`}
                        >
                            {option.text}
                        </button>
                    );
                })
            }
        </div>
    );

    const customOptions = {
        //     page: page1,
        // sizePerPage: sizePerPage1,
        // pageStartIndex: 1,
        // paginationSize: 50,
        // sizePerPage : 50,        
        sizePerPageRenderer,
        sizePerPageList: [
            {
                text: '50', value: 50
            }, {
                text: '100', value: 100
            },
            {
                text: '200', value: 200
            },
            {
                text: 'All', value: 0
            }
        ]

    };


    return (
        <>
            {/* <ToolkitProvider
                                keyField="id"
                                // data={[]}
                                columns={columns}
                                exportCSV>
                                {
                                    props => (
                                        <div>
                                            
                                            <BootstrapTable
                                                classes='table table-striped table-hover table-width'
                                                headerClasses='table-top'
                                                bootstrap4
                                                
                                                pagination={paginationFactory(customOptions)}
                                                {...props.baseProps}
                                               
                                                
                                               
                                            />
                                            <ExportCSVButtons {...props.csvProps}><i className='fa fa-download'></i> Export</ExportCSVButtons>
                                        </div>
                                    )
                                }
                            </ToolkitProvider> */}
            {/* <BootstrapTable keyField='id' data={ [] } columns={ columns } /> */}

            <ToolkitProvider
                keyField="customerName"
                data={demodata}
                columns={props.column}
                exportCSV>
                {
                    props => (
                        <div>
                            <div style={{ backgroundColor: '#fff', marginTop: '5px', textAlign: 'right' }}>
                                <ExportCSVButton disabled={true} {...props.csvProps}><i className='fa fa-download'></i> Export</ExportCSVButton>
                            </div>
                            <BootstrapTable
                                classes='table table-striped table-hover table-width'
                                headerClasses='table-top'
                                bootstrap4
                                keyField='customerName'
                                columns={props.column}
                                data={demodata}
                                filter={filterFactory()}
                                pagination={paginationFactory(customOptions)}
                                {...props.baseProps}
                            />

                        </div>
                    )
                }
            </ToolkitProvider>
        </>
    );
}

